import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject;
import styled from 'styled-components';
const Icon = styled.i.withConfig({
  shouldForwardProp: prop => !['size', 'name', 'iconPosition', 'fit', 'disabled'].includes(prop)
}).attrs(_ref => {
  let {
    size = '20',
    name
  } = _ref;
  return {
    size,
    name,
    className: "icon mi-".concat(size, "px mi-").concat(name)
  };
})(_templateObject || (_templateObject = _taggedTemplateLiteral([""])));
export default Icon;